export const USE_FIELD_UPDATE_DELAY = 300;
export const USE_SELECT_FIELD_UPDATE_DELAY = 0;
